module.exports = __webpack_public_path__ + "img/full3-min.149e699e.png";